module.exports = __webpack_public_path__ + "img/47.4664dbc5.jpg";